import {useLocalSearchParams} from "expo-router";
import {BookmarkedVideoScreen} from "@/components/media/BookmarkedVideoScreen";

export default function Bookmarks() {
    const {orgId} = useLocalSearchParams<{ orgId: string }>();
    return (
        <BookmarkedVideoScreen orgId={orgId}/>
    );
}
